interface QuickRepliesProps {
  options: string[];
  onSelect: (value: string) => void;
}

export function QuickReplies({ options, onSelect }: QuickRepliesProps) {
  if (!options.length) {
    return null;
  }

  return (
    <div data-testid="quick-replies" className="agent-animate-fade-up flex flex-wrap gap-2">
      {options.map((option, index) => (
        <button
          key={`${option}-${index}`}
          data-testid={`quick-reply-${index}`}
          onClick={() => onSelect(option)}
          className="rounded-xl border-2 border-black bg-white px-4 py-2 text-sm font-bold text-black shadow-[3px_3px_0px_0px_rgba(0,0,0,1)] transition-transform hover:-translate-y-1 hover:shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] active:translate-x-[2px] active:translate-y-[2px] active:shadow-none"
        >
          {option}
        </button>
      ))}
    </div>
  );
}
